export function declOfNum(number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}
export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (Math.floor(max) - Math.ceil(min) + 1)) + Math.ceil(min);
}
export function toNonExponential(num) {
    const matchWithExponental = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/);
    if (!matchWithExponental)
        num.toString();
    return num.toFixed(Math.max(0, (matchWithExponental[1] || '').length - +matchWithExponental[2]));
}
